// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pop-comment[data-v-240a21f5] .el-dialog__header {\n  padding: 16px 0 0;\n  height: 54px;\n  box-sizing: border-box;\n}\n.pop-comment[data-v-240a21f5] .el-dialog__body {\n  padding: 16px 36px 0 32px;\n}\n.pop-comment[data-v-240a21f5] .el-form-item {\n  margin-bottom: 26px;\n}\n.pop-comment[data-v-240a21f5] .el-dialog__footer {\n  padding: 6px 0 16px;\n}\n.pop-comment[data-v-240a21f5] .tips {\n  color: #939696;\n  font-size: 12px;\n}", ""]);
// Exports
module.exports = exports;
